import { financeDisclosure } from "@/content/capitalPartners";

/** Required general-information disclosure for finance-related pages. */
const FinanceNote = () => (
  <p
    data-testid="finance-disclosure"
    className="mt-12 pt-6 border-t border-charcoal/15 text-xs leading-relaxed text-charcoal/60 max-w-3xl"
  >
    {financeDisclosure}
  </p>
);

export default FinanceNote;
